import styled from 'styled-components'

export const Title = styled.h2`
  font-size: 2rem;
  line-height: 1.6;
  margin-bottom: 2.4rem;
  letter-spacing: normal;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    font-size: 2.4rem;
    line-height: 1.5;
    margin-bottom: 3.6rem;
  }
`

export const Category = styled.p`
  font-size: 1.4rem;
  margin-top: 5.6rem;
  margin-bottom: 0.8rem;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    margin: 1.6rem 0;
  }
`

export const TitleContainer = styled.div`
  flex: 0 1 100%;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    padding-left: 17.1%;
  }
`
